export const defaultProtocol = "https:";
